// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ApiService } from './api.service';

type IpResponse = {
    ip: string;
};

@Injectable({
    providedIn: 'root',
})
export class IPService {
    constructor(private readonly apiService: ApiService) {}

    public getIPAddress(): Observable<IpResponse> {
        //add the ipAddress to session as this shouldn't change and will save excessive api calls'
        if (sessionStorage.getItem('ipAddress') !== null) {
            return of(JSON.parse(sessionStorage.getItem('ipAddress')));
        }

        // let result = this.http.get("https://api.ipify.org/?format=json")
        const result = this.apiService.getV2$('api/ip', null, false).pipe(
            catchError((error) => {
                //return null ip if there is an error so that we don't prevent the application from throwing errors blocking functionality
                return of({
                    ip: null,
                });
            }),
            map((val: IpResponse) => {
                sessionStorage.setItem('ipAddress', JSON.stringify(val));
                return val;
            })
        );

        return result;
    }
}
